import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
import loadWishListModule from './modules/WishList.module';
const loadVoucherActivationModule = () => ({
    hasRouter: false,
    modules: [loadWishListModule(), loadSessionModule(), loadAuthenticationModule()],
});
export default loadVoucherActivationModule;
